import { ReactComponent as FireSuppressionSvg } from '../../assets/images/icons/pc-fire-suppression.svg'
import { ReactComponent as AccessSvg } from '../../assets/images/icons/pc-access.svg'
import { ReactComponent as EmergencySvg } from '../../assets/images/icons/pc-emergency.svg'
import { ReactComponent as MonitoredSvg } from '../../assets/images/icons/pc-monitored.svg'
import { ReactComponent as OperationsSvg } from '../../assets/images/icons/pc-operations.svg'
import { ReactComponent as VideoSvg } from '../../assets/images/icons/pc-video.svg'
import { ReactComponent as WaterSvg } from '../../assets/images/icons/pc-water.svg'
import { ProofCenterCategoryKeys } from 'constants/field-values'

const categoryMap: Record<ProofCenterCategoryKeys, any> = {
  FIRE_SAFETY: FireSuppressionSvg,
  ACCESS_CONTROL: AccessSvg,
  EMERGENCY: EmergencySvg,
  SECURITY: MonitoredSvg,
  OPERATIONS: OperationsSvg,
  SURVEILLANCE: VideoSvg,
  WATER: WaterSvg,
}

export {
  categoryMap
};